"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpMethod = void 0;
// local
const enum_1 = require("./enum");
/**
 * The http method types
 */
exports.HttpMethod = (0, enum_1.makeEnum)({
    /** A get request */
    Get: 'GET',
    /** A post request */
    Post: 'POST',
    /** A delete request */
    Delete: 'DELETE',
    /** A put request */
    Put: 'PUT',
    /** A patch request */
    Patch: 'PATCH',
});
//# sourceMappingURL=enums.js.map